import styled from 'styled-components'

export const ProfileContainer = styled.main`
  display: flex;
  flex-direction: column;
  & > div:first-child {
    display: flex;
    gap: 10px;
    padding-bottom: 2vh;
    border-bottom: 2px solid var(--color-secondary);
  }
  & h2 {
    font-size: 1.2em;
    color: var(--color-quaternary);
    font-weight: 600;
  }
`

export const SectionBoxes = styled.div`
  display: flex;
  margin-left: 1vw;
  margin-top: 2vw;
  gap: 2vw;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0;
  }
`

export const SectionBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2vh;
  padding: max(2vw, 2vh) 0 max(2vw, 2vh) 2vw;
  border-left: 2px solid var(--color-secondary);
  @media (max-width: 768px) {
    border: none;
    border-bottom: 2px solid var(--color-secondary);
  }
`

export const InfoItem = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
`
